import { createContext, useCallback, useContext } from "react";
import { withSqueezeRelief, type SqueezeRelief } from "@CommonUtils/pog/squeezeRelief";

/** The squeeze each item needs on the pog the DOM renderer is drawing (`computeNeededSqueeze`). */
export const DrawnSqueezeContext = createContext<ReadonlyMap<object, SqueezeRelief>>(new Map());

/** Measures `items` as they are drawn: squeezed only as much as their shelf needs. */
export const useDrawnSqueeze = () => {
  const relief = useContext(DrawnSqueezeContext);
  return useCallback(
    <T>(items: Iterable<object>, measure: () => T) => withSqueezeRelief(relief, measure, items),
    [relief],
  );
};
